import { AUTH_URL } from "@shared/constants";
import { AuthProvider } from "@shared/types";

import { authGet } from "./auth";

export const fetchSsoProvider = (ssoEmail: string): Promise<AuthProvider> => {
  return authGet<AuthProvider>(
    `${AUTH_URL}/sso?email=${encodeURIComponent(ssoEmail)}`
  );
};
